import React from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  function logoutFunc(ev) {
    ev.preventDefault();
    localStorage.removeItem('isLoggedIn');
    navigate('/');
    window.location.reload(); // لضمان تحديث حالة التطبيق بالكامل بنظافة
  }

  return (
    <footer id='footer' className='footer global-footer-wrapper'>
      <div className='footer-inner-container'>
        
        {/* القسم العلوي: الروابط الأساسية وشبكات التواصل */}
        <div className='footer-main-row'>
          
          {/* تحديث الروابط لتكون كلها عبر Link لمنع الـ Page Refresh */}
          <ul className="footer-navbar">
            <li><Link to="/">{t('headerLi0')}</Link></li>
            <li><Link to="/fields">{t('fieldsTitle')}</Link></li>
            <li><Link to="/team">{t('ourTeam')}</Link></li>
            <li><Link to="/articles">{t('ourArticles')}</Link></li>
            <li><Link to="/rules">{t('rules')}</Link></li>
          </ul>

          {/* منصات التواصل الاجتماعي بأيقونات مؤطرة فخمة */}
          <div className='footer-social-media'>
            <ul>
              <li><a href='/' aria-label="LinkedIn"><i className='fab fa-linkedin'></i></a></li>
              <li><a href='/' aria-label="Twitter"><i className='fab fa-twitter'></i></a></li>
              <li><a href='https://www.instagram.com/albarede_law/' target="_blank" rel="noreferrer" aria-label="Instagram"><i className='fab fa-instagram'></i></a></li>
              <li><a href='https://www.facebook.com/profile.php?id=61579797128484' target="_blank" rel="noreferrer" aria-label="Facebook"><i className='fab fa-facebook-f'></i></a></li>
            </ul>
          </div>

        </div>

        {/* خط الفصل البصري الدقيق المحيط بالخلفية */}
        <div className='footer-divider'></div>

        {/* القسم السفلي: الحقوق، الإدارة، والتوقيع */}
        <div className='footer-bottom-row'>
          
          {/* رابط لوحة التحكم (Admin / Logout) */}
          <div className='admin-auth-zone'>
            {isLoggedIn ? (
              <a className='auth-toggle-link logged-in' href='/' onClick={logoutFunc}>
                Logout (Admin)
              </a>
            ) : (
              <Link className='auth-toggle-link' to="/register">Admin Portal</Link>
            )}
          </div>

          {/* نص الحقوق والتوقيع الهندسي مصفوفين بشكل فخم */}
          <div className='copyright-signature-wrap'>
            <p className='copyright-text'>
              Copyright © 2026 | All Rights Reserved
            </p>
            <a 
              className='developer-signature'  
              href="https://api.whatsapp.com/send/?phone=%2B963935337980&text&type=phone_number&app_absent=0"  
              target="_blank" 
              rel='noreferrer'
            >
              Project By: Alghieth Melhem
            </a>
          </div>

        </div>

      </div>
    </footer>
  );
}

export default Footer;